import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAcoustic } from '@models/restore-id/acoustic';
import { IEDNA } from '@models/restore-id/edna';
import { ICMR } from '@models/restore-id/cmr';
import { ILocation } from '@models/restore-id/location';



@Injectable()
export class DetailService {
  private _detailUrl = 'api/detail';
  private _acousticUrl = 'api/acoustic';
  private _ednaUrl = 'api/edna';
  private _cmrUrl = 'api/cmr';

  constructor(private _httpClient: HttpClient) { }

  //#region Sample
  async createNewSample(sample: IAcoustic): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._detailUrl}`, sample).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async importSample(data: IAcoustic[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._detailUrl}/import`, { data }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getSamples(locationname: string): Promise<IAcoustic[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('locationname', locationname)

      this._httpClient.get<IAcoustic[]>(`${this._detailUrl}`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getSamplesByGroupId(groupid: string): Promise<IAcoustic[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('groupid', groupid);

      this._httpClient.get<IAcoustic[]>(`${this._detailUrl}/get-samples-by-group`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getLocationBySampleId(sampleId: string): Promise<ILocation> {
    return new Promise((resolve, reject) => {
      this._httpClient.get<ILocation>(`${this._detailUrl}/get-location/${sampleId}`, ).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async updateSample(id: string, updatedData: IAcoustic): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.put<void>(`${this._detailUrl}/${id}`, updatedData).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async deleteSample(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.delete<void>(`${this._detailUrl}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }
  //#endregion Sample


  //#region Acoustic
  async createNewAcoustic(instance: IAcoustic): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._acousticUrl}`, instance).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async importAcoustic(data: IAcoustic[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._acousticUrl}/import`, { data }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getAcoustics(locationname:string): Promise<IAcoustic[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('locationname', locationname);

      this._httpClient.get<IAcoustic[]>(`${this._acousticUrl}`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getAcoustic(locationname: string): Promise<IAcoustic> {
    return new Promise((resolve, reject) => {

      this._httpClient.get<IAcoustic>(`${this._acousticUrl}/${locationname}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async updateAcoustic(id: string, updatedData: IAcoustic): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.put<void>(`${this._acousticUrl}/${id}`, updatedData).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async deleteAcoustic(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.delete<void>(`${this._acousticUrl}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }
  //#endregion Acoustic

  //#region EDNA
  async createNewEDNA(instance: IEDNA): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._ednaUrl}`, instance).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async importEDNA(data: IEDNA[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._ednaUrl}/import`, { data }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getEDNAs(locationname: string): Promise<IEDNA[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('locationname', locationname);

      this._httpClient.get<IEDNA[]>(`${this._ednaUrl}`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getEDNA(locationname: string): Promise<IEDNA> {
    return new Promise((resolve, reject) => {

      this._httpClient.get<IEDNA>(`${this._ednaUrl}/${locationname}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async updateEDNA(id: string, updatedData: IEDNA): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.put<void>(`${this._ednaUrl}/${id}`, updatedData).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async deleteEDNA(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.delete<void>(`${this._ednaUrl}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }
  //#endregion EDNA

  //#region CMR
  async createNewCMR(instance: ICMR): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._cmrUrl}`, instance).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async importCMR(data: ICMR[]): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.post<void>(`${this._cmrUrl}/import`, { data }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getCMRs(locationname: string): Promise<ICMR[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('locationname', locationname);

      this._httpClient.get<ICMR[]>(`${this._cmrUrl}`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getCMR(locationname: string): Promise<ICMR> {
    return new Promise((resolve, reject) => {

      this._httpClient.get<ICMR>(`${this._cmrUrl}/${locationname}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async updateCMR(id: string, updatedData: ICMR): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.put<void>(`${this._cmrUrl}/${id}`, updatedData).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }

  async deleteCMR(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._httpClient.delete<void>(`${this._cmrUrl}/${id}`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }
  //#endregion CMR

}
